import { Component, OnInit, Input, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { AmlineService } from './amline.service';
import { ActivatedRoute, Router } from "@angular/router";
import { UserInfoService } from '../../services/user-info.service';
import { Amline } from 'src/app/model/quote/amline/amline.model';
import { environment } from '../../../environments/environment';
import { AMLIN_VEHICLE_OVERNIGHT_ADDRESSES } from './amlin-horsebox-api.constants';


@Component({
  selector: 'app-amline',
  templateUrl: './amline.component.html',
  styleUrls: ['./amline.component.css']
})
export class AmlineComponent implements OnInit {
  selectedIndex: number = 0;
  @Input() quote;
  full_details_tab = false;
  statement_of_facts_tab = false;
  payment_details = false;
  submission = false;
  staticData;
  modelObj = new Amline();
  url_id = this.route.snapshot.params.id;
  // CalculationDetails = new CalculationsDetails();


  constructor(private as: AmlineService, private route: ActivatedRoute, private sessionSt: LocalStorageService,
    private userService: UserInfoService, private cdr: ChangeDetectorRef, private router: Router) { }


  ngOnInit(): void {
    this.userService.getUserDetails();
    this.getAccessToken();
    this.getAmlineData();
  }

  ngOnChanges(changes: SimpleChanges) {
    
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  authDetails: string = '';
  getAccessToken() {
    let data = {
      'client_id': environment.AMLINE_CLIENT_ID,
      'client_secret': environment.AMLINE_CLIENT_SECRET,
      'grant_type': environment.AMLINE_GRANT_TYPE,
      'scope': environment.AMLINE_SCOPE,
    }
    this.as.getAccessToken(data)
      .subscribe(
        (response: any) => {
          if (response.access_token) {
            this.authDetails = response;
            this.getStaticData(response);
          }
        },
        (error) => {
          ;
        }
      );
  }

  // GET STATIC DATA
  getStaticData(response) {
    this.as.getStaticData(response)
      .subscribe(
        (response: any) => {
          if (response.meta) {
            this.staticData = response.meta;
          }
        },
        (error) => {
          ;
        }
      );
  }
  // GET AMLINE DATA
  apiModelObj;
  getAmlineData(id = '') {
    if (this.route.snapshot.params.id) {
      let quote_id = this.route.snapshot.params.id;
      let temp_modelObj = this.modelObj;
      if(id) {
        quote_id = id;
      }

      this.as.getAmlineData(quote_id)
        .subscribe(
          (response: any) => {
            
            if (response.result) {
              response.result.quote_data.quote_versions[0].amlin_data.data.attributes.application.vehicles.forEach((res) => {
                let drivers = [];
                if (res.drivers && res.drivers.length > 0) {
                  res.drivers.forEach((d) => {
                    drivers.push(d);
                  })
                  res.drivers = drivers;
                }
  
              })

              const latestQuoteVersion = response.result.quote_data.quote_versions[0];
              const previousApplication = this.apiModelObj?.amlin_data?.data?.attributes?.application || this.modelObj;
              if (latestQuoteVersion?.amlin_data?.data?.attributes?.application && previousApplication) {
                this.mergeVehicleOvernightAddresses(latestQuoteVersion.amlin_data.data.attributes.application, previousApplication);
              }
              this.apiModelObj = latestQuoteVersion;
              this.modelObj = latestQuoteVersion;
              
              if(response.result.quote_data.quote_versions[0].amlin_status == "referred") {
                this.router.navigate(['/amline/quote-details/', this.route.snapshot.params.id]);
              }
            }
          },
          (error) => {
            ;
          }
        );
    }
  }

  modelObjUpdated(data) {
    const previousApplication = this.apiModelObj?.amlin_data?.data?.attributes?.application || this.modelObj;
    const mergedApplication = JSON.parse(JSON.stringify(data || {}));
    if (previousApplication) {
      this.mergeVehicleOvernightAddresses(mergedApplication, previousApplication);
    }
    if (this.apiModelObj?.amlin_data?.data?.attributes) {
      const preservedId = mergedApplication.id || this.apiModelObj.amlin_data.data.id;
      const preservedReference = mergedApplication.reference || this.apiModelObj.amlin_data.data.attributes.reference;
      const preservedStatus = mergedApplication.status || this.apiModelObj.amlin_data.data.attributes.status;
      if (preservedId) {
        mergedApplication.id = preservedId;
      }
      this.apiModelObj = {
        ...this.apiModelObj,
        amlin_data: {
          ...this.apiModelObj.amlin_data,
          data: {
            ...this.apiModelObj.amlin_data.data,
            id: preservedId,
            attributes: {
              ...this.apiModelObj.amlin_data.data.attributes,
              reference: preservedReference,
              status: preservedStatus,
              application: mergedApplication,
            },
          },
        },
      };
    }
    this.modelObj = mergedApplication;
    this.selectedIndex += 1;
  }

  private mergeVehicleOvernightAddresses(targetApplication: any, sourceApplication: any) {
    if (!targetApplication || !sourceApplication) return;
    const targetVehicles = Array.isArray(targetApplication.vehicles) ? targetApplication.vehicles : [];
    const sourceVehicles = Array.isArray(sourceApplication.vehicles) ? sourceApplication.vehicles : [];
    if (!targetVehicles.length || !sourceVehicles.length) return;

    targetApplication.vehicles = targetVehicles.map((vehicle: any, idx: number) => {
      const sourceVehicle = sourceVehicles[idx] || {};
      const targetOvernight = vehicle?.[AMLIN_VEHICLE_OVERNIGHT_ADDRESSES];
      const sourceOvernight = sourceVehicle?.[AMLIN_VEHICLE_OVERNIGHT_ADDRESSES];
      if ((!Array.isArray(targetOvernight) || targetOvernight.length === 0) && Array.isArray(sourceOvernight) && sourceOvernight.length > 0) {
        return {
          ...vehicle,
          [AMLIN_VEHICLE_OVERNIGHT_ADDRESSES]: sourceOvernight,
          postcode: vehicle?.postcode || sourceVehicle?.postcode || null,
        };
      }
      return vehicle;
    });
  }

  isFleetActivated: boolean = false;
  is_fleet(event) {
    this.isFleetActivated = event;
  }



  tabChanged(event) {
    //   var a = this.quoteDetailsForChildTemplates;
    //   this.quoteDetailsForChildTemplates = null;
    //   this.quoteDetailsForChildTemplates = a;
    //   if (event.index == 0) {
    //     this.showHideAEIOSection();
    //     if (this.quoteDetailsForChildTemplates.vet_fee_sum_insured_id == '713b6924-5b80-4c76-a469-f767594bc7d1') {
    //       this.quoteDetailsForChildTemplates.full_quote_section = true;
    //       this.quoteDetailsForChildTemplates.aeio_quote_section = false;
    //     }
    //     // this.quoteDetailsForChildTemplates.aeio_quote_section = true;
    //     // this.quoteDetailsForChildTemplates.full_quote_section = true;
    //     this.quoteDetailsForChildTemplates.indicativePage = true;
    //   } else {
    //     if (this.quoteDetailsForChildTemplates.is_aeio == 1) {
    //       this.quoteDetailsForChildTemplates.aeio_quote_section = true;
    //       this.quoteDetailsForChildTemplates.full_quote_section = false;
    //     } else {
    //       this.quoteDetailsForChildTemplates.aeio_quote_section = false;
    //       this.quoteDetailsForChildTemplates.full_quote_section = true;
    //     }
    //     this.quoteDetailsForChildTemplates.indicativePage = false;
  }


  // }

  // activateFullDetailsTab() {
  //   this.full_details_tab = true;
  //   this.quoteDetailsForChildTemplates.indicativePage = false;
  //   this.selectedIndex += 1;
  // }

  // jumpToIndicativeQuoteDetilsTab() {
  //   this.quoteDetailsForChildTemplates.indicativePage = true;
  //   this.selectedIndex = 0;
  // }
  // jumpToStatementOfFactTab() {
  //   this.statement_of_facts_tab = true;
  //   this.selectedIndex = 2;
  // }
  // jumpToFullQuoteDetilsTab() {
  //   this.full_details_tab = true;
  //   this.selectedIndex = 1;
  // }
  // jumpToPayment() {
  //   this.payment_details = true;
  //   this.selectedIndex = 3;
  // }
  // jumpToUnderWritingSubmissionTab() {
  //   this.submission = true;
  //   this.selectedIndex = 4;
  // }

}
